export class Campaign {
    id?: any;
    date?: string;
    username?: string; //first name + last name.. publisher
    method?: string;
    status?: string;
    amount?: number;
    currency?: string;
    exchange?: number;
    total?: number;
  }

  // używane w widoku pojedynczej oferty dla administratora
  export class Offer {
    offerId?: any;
    advertiserOfferId?: any;
    offerName?: string;
    countryid: number;
    countryname: string;
    countryalpha2Code: string;
    advertisername?: string;
    payout?: number;
    offerGlobalStatus?: string;
    offerPublisherStatus?: any;
    offerUrl?: string;
    offerPreviewUrl?: string;
    offerCategoryId?: number;
    offerCategoryname: string;
    offerDevices: any[];
    statusglobalStatus: string;
    statuspublishersStatusDisabled: any[];
    createdAtUtc?: string;
  }

  export class OfferStatus {
    statusId: number; // Active=1 Disabled=3
  }

  export class OfferEdit {
    offerCap?: number;
    offerLockingTitle?: string;
    offerLockingDescription?: string;
    offerName?: string;
  }

  export class OffersImport {
    lastImportUtc?: string;
    advertiserName?: string;
    expiredOffers?: number;
    activeOffers?: number;
    lockedOffers?: number;
    allOffers?: number;
  }

  // używane w widoku Offer-Settings dla administratora
  export class sortModeClass {
    id: number; // DefaultSoft=1 frameWindows=2
    EpcInDays: number;
  }
